import { DragNDrogPoolArrayContainerComponent } from './drag-ndrog-pool-array-container/drag-ndrog-pool-array-container.component';
import { Component, OnInit, isDevMode, ViewChild, Injectable, ChangeDetectorRef } from '@angular/core';
import { tools } from "./global/services/tools";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { VersionCheckService } from './global/services/version-check.service';
import { Router, NavigationStart } from '@angular/router';
import { CommonModule, Location, PlatformLocation } from "@angular/common";
import { RoutingStateService } from './global/services/routing-state.service';
import { environment } from '../environments/environment';
import { first } from 'rxjs/operators';
import { deviceService } from './global/services-hardware/deviceService';
import { application } from './global/services/shared-menu.service';
import { GetJsonObjectService } from './global/services/get-json-object.service';
import { childWindows, CommunicationService, SharedMultiWindowsService } from './global/multi-window-container/communication.service';
import { MaterialModule } from './material-module';
import { AlertComponent } from './global/alert/alert.component';

@Component({
  selector: 'app-root',
  imports: [
    MaterialModule,
    CommonModule,
    AlertComponent,
    DragNDrogPoolArrayContainerComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true
})
export class AppComponent implements OnInit {


  //in case of back button if last 3 history zre due to load back to the four 
  // @HostListener('window:popstate', ['$event'])
  // onPopState(event) {
  //   console.log('---- Back button pressed', event);
  // }

  public loaded: string = "NLOAD";
  public multiWindow: boolean = false;
  private sharedUrl: string = "";
  public domainLogin: string = "";
  private uuidReceive: boolean = false;
  private userNameReceive: boolean = false;
  private accessReceive: boolean = false;
  private oidcInfosReceive: boolean = false;
  private appTitle: string = "";

  public sanitizeSharedUrl: any;
  public isLocalTest: boolean = false;
  private initDone: boolean = false;
  public selectedAppUrl: string = "";
  public loading: boolean = true;
  public iframeHeight: number = 800;
  public iframeWidth: number = 1200;
  public societySelected: any;
  public AppArrayForHtml: { apps: any[]; adminApps: any[]; } = {
    apps: [],
    adminApps: []
  };
  private currentAppSubDomain: string = "";
  private pathNameOnload: string[] = [];
  private paramsStrOnLoad: string = "";
  private lastPing: number = 0;
  homeApp: application | undefined;


  constructor(private tools: tools, private sanitizer: DomSanitizer, public router: Router,
    private location: Location, private sharedMultiWindowsService: SharedMultiWindowsService,
    private deviceService: deviceService, private communicationService: CommunicationService,
    versionCheckService: VersionCheckService, private cdRef: ChangeDetectorRef,
  ) {
    this.paramsStrOnLoad = window.location.search;
    if (isDevMode()) {
      console.log(" -- pathNameOnload --", this.pathNameOnload);
    }

    let versionApp: string = environment.appVersion.toString();
    localStorage.setItem("version", versionApp);
    localStorage.removeItem("currentUserLogin");
    localStorage.removeItem("userSession");
    localStorage.removeItem("accessList");

    this.sharedUrl = environment.apiFlowConfig.sharedUrl;
    this.domainLogin = environment.apiFlowConfig.loginUrl;

    console.log("constructor of app component has been call");
    let subDomaine = window.location.origin.replace("https://", "");
    subDomaine = subDomaine.replace("http://", "");
    subDomaine = subDomaine.replace("www.", "");
    versionCheckService.initVersionCheck(window.location.origin);
    this.sanitizeSharedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.sharedUrl);


    this.tools.delay(20000).then(res => {
      //start parent ping tools after 20000 sec
      this.idParentStillAlive();
    });
  }

  async ngOnInit() {
    this.loaded = "NLOAD";
    window.addEventListener("message", (event: any) => {
      let iframeApp = document.getElementsByTagName('iframe');
      let { action, key, value } = event.data;
      let str: string;
      if (action == null)
        return;
      switch (action) { //add event listners
        case 'returnData':
          if (key == "userSession") {
            this.oidcInfosReceive = true;
            localStorage.setItem(key, value);
            this.runApps();
          }
          else if (key == "uuid") {
            this.uuidReceive = true;
            localStorage.setItem(key, value);
            this.runApps();
          }
          else if (key == "currentUserLogin") {
            this.userNameReceive = true;
            localStorage.setItem(key, value);
            this.runApps();
          }
          else if (key == "accessList") {
            this.accessReceive = true;
            localStorage.setItem(key, value);
            this.runApps();
          }
          else
            localStorage.setItem(key, value);
          if (iframeApp != undefined && iframeApp.length == 2 && iframeApp[1].contentWindow) {
            iframeApp[1].contentWindow.postMessage({
              action: action,
              key: key,
              value: value
            }, "*");
          }
          break;
        case 'appReady': //case send events
          let iframe: any = document.getElementsByTagName('iframe')[0];
          iframe.contentWindow.postMessage({
            action: 'get',
            key: 'uuid'
          }, this.sharedUrl);

          iframe.contentWindow.postMessage({
            action: 'get',
            key: 'currentUserLogin'
          }, this.sharedUrl);

          iframe.contentWindow.postMessage({
            action: 'get',
            key: 'userSession'
          }, this.sharedUrl);

          iframe.contentWindow.postMessage({
            action: 'get',
            key: 'me'
          }, this.sharedUrl);
          iframe.contentWindow.postMessage({
            action: 'get',
            key: 'accessList'
          }, this.sharedUrl);
          break;
        case 'logoutDone':
          try {
            this.loaded = "NLOAD";
            localStorage.clear();
            this.deviceService.encrypteDataLocalStorage("lastAppUrl", JSON.stringify(window.location.href), false);
            localStorage.removeItem("userSession");
            localStorage.removeItem("currentUserLogin");
          }
          catch (e) {
            console.log(e);
          }
          window.location.href = this.domainLogin;
          break;
        case 'get':
          //ask get to shared
          if (iframeApp != undefined && iframeApp.length == 2 && iframeApp[0].contentWindow) {
            iframeApp[0].contentWindow.postMessage({
              action: 'get',
              key: key,
            }, environment.apiFlowConfig.sharedUrl);
          }
          break;
        case 'urlPopstate':
          if (isDevMode())
            console.log("[extranetContainer] : urlPopstate", value);
          if (value.includes("load")) { //if it's a popstate <=> back button with a "load" url => goto home app
            this.location.replaceState("home");
          }
          else
            this.location.replaceState(value);
          this.loading = false;
          break;
        case 'save':
          //send data to shared 
          localStorage.setItem(key, value);
          break;
        case 'fullScreen':
          if (value == true)
            document.documentElement.requestFullscreen();
          else
            document.exitFullscreen();
          break;
        case "delete":
          localStorage.removeItem(key);
          if (iframeApp[1].contentWindow)
            iframeApp[1].contentWindow.postMessage({
              action: 'delete',
              key: key,
            }, environment.apiFlowConfig.sharedUrl);
          break;
        case 'dispatch':
          if (iframeApp[1].contentWindow)
            iframeApp[1].contentWindow.postMessage({
              action: 'dispatch',
              value: value,
              key: key
            }, "*");
          this.execAction(value);
          break;
        case 'inFrameAppReady':
          if (iframeApp[1].contentWindow)
            iframeApp[1].contentWindow.postMessage({
              action: "appReady",
              key: ''
            }, "*");
          break;
        case "companyList":
          localStorage.setItem("companyList", value);
          this.setSubscriberInformation()
          break;
        case "currentSubscriberID":
          localStorage.setItem("currentSubscriberID", value);
          this.setSubscriberInformation()
          break
        case "closeRequest":
          window.close()
          break
        case "ping":
          if (key == "windowId") //if ping is asked for current windowsId => return ping Ok 
          {
            this.lastPing = new Date().getTime();
            if (!(event.source instanceof MessagePort) && !(event.source instanceof ServiceWorker) && this.communicationService.localWindow != undefined && value == this.communicationService.localWindow.guid) {
              event.source.postMessage({
                action: 'handlePing',
                key: "windowId",
                value: this.communicationService.localWindow.guid
              }, "*");
              if (this.communicationService.parent == undefined) {
                this.communicationService.parent = event.source;
                this.sendChilReady(event)
              }
            }
          }
          break;
        default:
          break;
      }
    });
  }

  public runApps() {
    document.title = "Vivier D4"
    if (this.initDone == true)
      return;
    console.log(environment.apiFlowConfig.apiName + " - runApps")
    if (this.userNameReceive == true && this.oidcInfosReceive == true && this.uuidReceive == true && this.accessReceive == true) {
      if (localStorage.getItem("currentUserLogin") == null &&
        localStorage.getItem("userSession") == null &&
        localStorage.getItem("accessList") == null) {
        this.logout();
      }
      else {

        this.loaded = "LOAD";
        this.loading = true;
        this.initDone = true;
        this.iframeHeight = document.getElementsByTagName('body')[0].clientHeight;
        this.iframeWidth = document.getElementsByTagName('body')[0].clientWidth;
        //get current path => find right apps

        this.selectedAppUrl = environment.apiFlowConfig.homeAppUrl;

        if (isDevMode()) {
          console.log(" -- urlPaths --", this.pathNameOnload);
        }

        this.paramsStrOnLoad = this.paramsStrOnLoad.replace('?', '')
        let paramsStrListOnLoad = this.paramsStrOnLoad.split("&")
        let paramOnLoad: any = {}
        paramsStrListOnLoad.forEach(paramStr => {
          let params = paramStr.split("=")
          if (params.length == 2) {
            paramOnLoad[params[0]] = params[1]
          }
        })

        let currentChild: childWindows =
        {
          guid: paramOnLoad["guid"],
          name: paramOnLoad["name"],
          urlParent: window.location.href,
          creationDate: paramOnLoad["creationDate"],
          lastPing: paramOnLoad["lastPing"],
          closeOnNavigationChange: paramOnLoad["closeOnNavigationChange"],

        }
        this.communicationService.initialise(currentChild)
        if (paramOnLoad["name"] != undefined)
          this.appTitle = paramOnLoad["name"]

        let societyParam = "";
        let societyId = this.getCompanyFromUrl();
        if (societyId != undefined)
          societyParam = "?cpny=" + societyId;

        this.location.replaceState("/");
      }
    }
  }

  private setSubscriberInformation() {

    if (localStorage.getItem("companyList") == undefined || localStorage.getItem("currentSubscriberID") == undefined)
      return

    let subscriberList = this.deviceService.decryptDataLocalStorage("companyList")
    let subscriberID = this.deviceService.decryptDataLocalStorage("currentSubscriberID")

    this.societySelected = subscriberList.find((cmpItem: any) => { return cmpItem.companyGuid == subscriberID });
    if (this.societySelected != null) {
      this.deviceService.encrypteDataLocalStorage("currentSubscriberID", JSON.stringify(this.societySelected.companyGuid), false);
      this.deviceService.encrypteDataLocalStorage("subscriberHost", JSON.stringify(this.societySelected.host), false);
      this.deviceService.encrypteDataLocalStorage("subscriberDatabaseName", JSON.stringify(this.societySelected.subscriberDatabaseName), false);
      this.deviceService.encrypteDataLocalStorage("subscriberDatabasePort", JSON.stringify(this.societySelected.subscriberDatabasePort), false);
    }
  }

  private async idParentStillAlive() {
    while (true) {
      if (this.lastPing != 0 && (new Date().getTime() - this.lastPing > 4000)) {
        this.sharedMultiWindowsService.setIsParentStilAlive(false);
      }
      else
        this.sharedMultiWindowsService.setIsParentStilAlive(true);
      await this.tools.delay(500);
    }
  }


  private sendChilReady(parentWindows: any) {
    console.log("pool send child ready", parentWindows)
    parentWindows.source.postMessage({
      action: 'event',
      key: "childReady",
      value: ""
    }, "*");
  }

  public emitEvent(eventName: string, data: any, child?: childWindows) {
    let bChannel = new BroadcastChannel("D4detachedTabsChannel");
    bChannel.postMessage({
      action: 'event',
      sourcePath: window.location.pathname,
      destinationPath: null,
      key: eventName,
      value: data
    });
  }

  private getCompanyFromUrl(): string | undefined {
    let selectedCompany = undefined;
    if (this.paramsStrOnLoad.includes("cpny")) {
      this.paramsStrOnLoad = this.paramsStrOnLoad.replace("?", "");
      let paramsSegments = this.paramsStrOnLoad.split("&");
      //find cpny param
      let cpnySegment = paramsSegments.find(segment => {
        return segment.includes("cpny");
      });
      if (cpnySegment != undefined)
        selectedCompany = cpnySegment.split("=")[1];
    }
    return selectedCompany;
  }

  private execAction(keyAction: string) {
    let iframeApp = document.getElementsByTagName('iframe');
    switch (keyAction) {
      case 'logout':
        this.clearLocalStorage();
        if (iframeApp[0].contentWindow)
          iframeApp[0].contentWindow.postMessage({
            action: 'dispatch',
            value: 'logout',
            key: 'logout',
          }, environment.apiFlowConfig.sharedUrl);
        break;
      case 'dispatch':
        if (iframeApp[1].contentWindow)
          iframeApp[1].contentWindow.postMessage({
            action: 'dispatch',
            value: 'logout',
            key: 'logout',
          }, environment.apiFlowConfig.sharedUrl);
        break;
      default:
        // strErrorMessage = strErrorMessage + result.errors[i].description;
        break;
    }
  }

  private clearLocalStorage() {
    try {
      let lastAppUrl = localStorage.getItem("lastAppUrl");
      localStorage.clear();
      if (lastAppUrl != null && lastAppUrl != "")
        localStorage.setItem("lastAppUrl", lastAppUrl);
    }
    catch (e) {
      console.log(e);
    }
  }

  public logout() {
    let iframe: any = document.getElementsByTagName('iframe')[0];
    try {
      // localStorage.removeItem("userSession");
      // localStorage.removeItem("currentUserLogin");
      localStorage.clear();
      iframe.contentWindow.postMessage({
        action: 'dispatch',
        key: '',
        value: 'logout',
      }, this.sharedUrl);
      this.loaded = "NLOAD";
      window.close()
    }
    catch (e) {
      if (isDevMode())
        console.log(e);
    }
  }

}

